var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"health"},[_c('div',{staticClass:"health-header"},[_vm._v("健康码详情")]),_c('div',{staticClass:"health-main"},_vm._l((_vm.qrCodeList),function(item){return _c('div',{key:item,staticStyle:{"display":"flex","flex-wrap":"wrap"}},[_c('img',{key:item,staticClass:"info",class:{go: _vm.rotate},attrs:{"src":item.qrcodeUrl}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }